import { useCart } from '../context/CartContext';
import './ProductCard.css';

export default function ProductCard({ product, delay = 0 }) {
  const { addToCart } = useCart();
  const { name, brand, price, oldPrice, emoji, rating, reviews, badge } = product;

  const badgeLabel = badge === 'hot' ? '🔥 HOT' : badge === 'new' ? '✨ NEW' : badge === 'sale' ? '💰 SALE' : null;

  return (
    <div className="prod-card" style={{ animationDelay: `${delay}s` }}>
      {badgeLabel && <span className={`prod-badge badge-${badge}`}>{badgeLabel}</span>}
      <button className="prod-wish" onClick={() => {}}>❤️</button>
      <div className="prod-img">{emoji}</div>
      <div className="prod-info">
        <div className="prod-brand">{brand}</div>
        <div className="prod-name">{name}</div>
        <div className="prod-rating">
          <span className="stars">{'★'.repeat(Math.floor(rating))}{'☆'.repeat(5 - Math.floor(rating))}</span>
          <span className="rating-count">{rating} ({reviews})</span>
        </div>
        <div className="prod-bottom">
          <div className="prod-price">
            <span className="price-current">${price}</span>
            {oldPrice && <span className="price-old">${oldPrice}</span>}
          </div>
          <button className="prod-add" onClick={() => addToCart(product)}>+</button>
        </div>
      </div>
    </div>
  );
}
